import { isTestMode } from "lib/environment";
import BaseService from "./BaseService";

interface State {
  online: boolean;
}

export class OnlineService extends BaseService<State> {
  private static instance: OnlineService | null = null;
  private started = false;

  get initialState(): State {
    return {
      online: typeof navigator !== "undefined" ? navigator.onLine : true,
    };
  }

  /**
   * Get the singleton instance of OnlineService
   */
  static getInstance(): OnlineService {
    if (!OnlineService.instance) {
      OnlineService.instance = new OnlineService();
      OnlineService.instance.start();
    }
    return OnlineService.instance;
  }

  /**
   * Clear the singleton instance (useful for testing)
   */
  static clearInstance(): void {
    OnlineService.instance?.stop();
    OnlineService.instance = null;
  }

  private handleOnlineChange = () => {
    this.state.online = navigator.onLine;
  };

  private start() {
    if (this.started || typeof window === "undefined") return;
    this.started = true;
    this.state.online = navigator.onLine;
    window.addEventListener("online", this.handleOnlineChange);
    window.addEventListener("offline", this.handleOnlineChange);
  }

  private stop() {
    if (!this.started || typeof window === "undefined") return;
    this.started = false;
    window.removeEventListener("online", this.handleOnlineChange);
    window.removeEventListener("offline", this.handleOnlineChange);
  }
}

export const onlineService = OnlineService.getInstance();
export default onlineService;

if (isTestMode()) {
  // @ts-expect-error - This is a test mode only
  window.onlineService = onlineService;
}
